export default function BlogsListSkeleton() {
  return (
    <div className="container relative mx-auto bg-white px-8 pb-8 lg:pb-16">
      {/* Header skeleton */}
      <div className="sticky top-[60px] z-10 flex flex-col-reverse justify-between bg-white py-4 lg:w-full lg:flex-row">
        <div className="flex flex-wrap gap-3">
          {/* Category buttons skeleton */}
          <div className="h-10 w-20 animate-pulse rounded-md bg-gray-300"></div>
          <div className="h-10 w-24 animate-pulse rounded-md bg-gray-300"></div>
          <div className="h-10 w-28 animate-pulse rounded-md bg-gray-300"></div>
          <div className="w-22 h-10 animate-pulse rounded-md bg-gray-300"></div>
        </div>
        <div className="mb-4 flex flex-row items-center justify-between gap-4 lg:mb-0">
          {/* Search skeleton */}
          <div className="h-10 w-full animate-pulse rounded-lg bg-gray-300 sm:max-w-lg"></div>
          {/* Sort dropdown skeleton */}
          <div className="h-10 w-32 animate-pulse rounded-md bg-gray-300"></div>
        </div>
      </div>

      {/* Blog posts grid skeleton */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 8 }).map((_, index) => (
          <div
            key={index}
            className="animate-pulse overflow-hidden rounded-lg border border-gray-200 bg-white"
          >
            <div className="aspect-[4/3] bg-gray-200"></div>
            <div className="flex h-[280px] flex-col p-6">
              <div className="mb-3 h-4 w-20 rounded-full bg-gray-300"></div>
              <div className="mb-2 h-5 w-full bg-gray-300"></div>
              <div className="mb-3 h-5 w-3/4 bg-gray-300"></div>
              <div className="mb-2 h-4 w-full bg-gray-300"></div>
              <div className="mb-4 h-4 w-2/3 flex-grow bg-gray-300"></div>
              <div className="mt-auto border-t border-gray-200 pt-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="h-8 w-8 rounded-full bg-gray-300"></div>
                    <div className="h-4 w-20 bg-gray-300"></div>
                  </div>
                  <div className="h-4 w-24 bg-gray-300"></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
